import { useEffect, useState } from 'react';
import './App.css';
import { SeasonContext, SettingsContext } from './components/contexts';
import Layout from './layout/layout';
import { storageService } from './services/storageService';
import { Settings } from './services/models';

function App() {
  const [settings, setSettings] = useState<Settings>();
  const [season, setSeason] = useState(new Date().getFullYear());

  useEffect(() => {
    storageService.getInfoFile('settings.json')
      .then((text) => setSettings(JSON.parse(text)))
      .catch((e) => console.error(e));
  }, [])
  return (
    <SettingsContext.Provider value={{ settings, setSettings }}>
      <SeasonContext.Provider value={{ season, setSeason }}>
        <Layout><></></Layout>
      </SeasonContext.Provider>
    </SettingsContext.Provider>
  );
}

export default App;
